import { useContext } from 'react';

import { ClientContext } from '../contexts/ClientContext';
import { APIClient } from '../services/api';

export default function useAPIClient(): APIClient {
  return useContext(ClientContext);
}
